import { ToastOptions } from './toastOptions'
import { useToastProvider } from './useToastProvider'

type UseToastOptions = Omit<ToastOptions, 'message'>

export function useToast() {
  const toastProvider = useToastProvider()
  return {
    show(message: string, options: UseToastOptions = {}) {
      if (!options.type) options.type = 'success'
      toastProvider.toasts.value.push({message, ...options})
    },
    primary(message: string, options: UseToastOptions = {}) {
      options.type = 'primary'
      return this.show(message, options)
    },
    success(message: string, options: UseToastOptions = {}) {
      options.type = 'success'
      return this.show(message, options)
    },
    error(message: string, options: UseToastOptions = {}) {
      options.type = 'danger'
      return this.show(message, options)
    }
  }
}